import mixpanel from 'mixpanel-browser';

const MIXPANEL_TOKEN = process.env.REACT_APP_MIX_PANEL_ID;


mixpanel.init(MIXPANEL_TOKEN);

export const trackEvent = (eventName, props = {}) => {
  mixpanel.track(eventName, props);
};

export const identifyUser = (userId, userData = {}) => {
  mixpanel.identify(userId);
  mixpanel.people.set(userData);
};

export const resetMixpanel = () => {
  mixpanel.reset(); 
};